__webpack_require__.p = "/public/tools/stardew-crops-profit-calculator/";